<!--  -->
<template>
  <div>
    <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="100px" class="demo-ruleForm">
      <el-form-item label="活动名称" prop="name">
        <el-input v-model="ruleForm.name" v-model.trim="ruleForm.name" style="width: 250px" @input="ruleForm.name = ruleForm.name.replace(reg, '')" />
      </el-form-item>
      <el-form-item label="活动内容">
        <div v-for="item,index in ruleForm.product_info" :key="index" class="activityAmount">
          <el-form-item label="充值类型">
            <el-radio-group v-model="item.charge_type">
              <el-radio label="书币充值" />
              <el-radio label="包年" />
              <el-radio label="包季" />
              <el-radio label="包月" />
            </el-radio-group>
          </el-form-item>
          <el-form-item label="活动金额">
            <div v-if="!item.charge_type || item.charge_type === '书币充值'" class="item">
              充<el-input v-model="item.price" style="width: 100px" type="number" />送<el-input v-model="item.given" type="number" style="width:100px" />
            </div>
            <div v-else>
              <el-input v-model="item.price1" style="width: 180px;" type="number" /><span>{{ item.charge_type }}</span>
            </div>
          </el-form-item>
          <el-form-item label="限购次数">
            <el-radio-group v-model="item.limit">
              <!-- <el-radio label="一次" />
              <el-radio label="两次" />
              <el-radio label="三次" />
              <el-radio label="无限次" /> -->
              <el-radio :label="1">一次</el-radio>
              <el-radio :label="2">两次</el-radio>
              <el-radio :label="3">三次</el-radio>
              <el-radio :label="0">无限次</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="附赠优惠券">
            <el-radio-group v-model="item.is_send">
              <!-- <el-radio label="不赠送" />
              <el-radio label="赠送" /> -->
              <el-radio :label="0">不赠送</el-radio>
              <!-- <el-radio :label="1">赠送</el-radio> -->
            </el-radio-group>
          </el-form-item>
          <i
            v-if="index"
            class="el-icon-error"
            style="position: absolute;top: 7px;right: 4px;font-size: 20px;cursor: pointer;"
            @click="ruleForm.product_info.splice(index, 1)"
          />
        </div>
        <div class="addActivityAmount" @click="addActivityContent">添加活动内容 {{ ruleForm.product_info.length + '/' + 3 }}</div>
      </el-form-item>
      <el-form-item label="是否永久活动">
        <!-- <el-checkbox-group v-model="ruleForm.permanentActivityOrNot">
          <el-checkbox label="是否永久活动" name="type" />
        </el-checkbox-group> -->
        <el-select v-model="ruleForm.permanentActivityOrNot" placeholder="请选择" @change="active">
          <el-option
            v-for="item in activeoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="ruleForm.permanentActivityOrNot === 1" label="期限选择">
        <el-select v-model="time_type" placeholder="请选择">
          <el-option
            v-for="item in timeoptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-if="ruleForm.permanentActivityOrNot === 1 && time_type === 2" label="固定天数" prop="appoint_day">
        <el-input v-model="ruleForm.appoint_day" style="width:300px" placeholder="请输入固定天数" type="number" :onkeyup="ruleForm.appoint_day = ruleForm.appoint_day.replace(/[^A-z0-9]/, '')" />
      </el-form-item>
      <el-form-item v-if="ruleForm.permanentActivityOrNot === 1 && time_type === 1" label="活动时间" prop="date">
        <el-date-picker
          v-model="ruleForm.date"
          format="yyyy-MM-dd HH:mm:ss"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width:410px"
          :picker-options="pickerOptions"
          :clearable="false"
          @change="datavalue"
        />
      </el-form-item>
      <!-- <el-form-item label="活动入口">
        <el-checkbox-group v-model="ruleForm.enter_point">
          <el-checkbox label="banner" name="enter_point">阅读底部banner</el-checkbox>
          <el-checkbox label="reader_alert" name="enter_point">签到回复</el-checkbox>
        </el-checkbox-group>
      </el-form-item> -->
      <el-form-item label="可见用户">
        <el-radio-group v-model="ruleForm.user_type">
          <el-radio label="all">全部用户</el-radio>
          <!-- <el-radio label="已付费用户" />
          <el-radio label="未付费用户" /> -->
        </el-radio-group>
      </el-form-item>
      <el-form-item label="活动主题" prop="theme">
        <div v-if="!ruleForm.theme" class="upImgBox" @click="dialogVisible = true" />
        <img v-else class="" style="width: 100px; height: 100px; cursor: pointer;" :src="ruleForm.theme.item.img" @click="dialogVisible = true">
      </el-form-item>
      <el-form-item label="签到文案">
        <el-radio-group v-model="ruleForm.sign_text">
          <el-radio label="">系统文案</el-radio>
          <!-- <el-radio label="自定义文案" /> -->
        </el-radio-group>
        <el-input v-if="ruleForm.sign_text === '自定义文案'" v-model="ruleForm.sign_text1" placeholder="请输入自定义文案" />
      </el-form-item>
    </el-form>
    <div>
      <el-button type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
      <el-button>取消</el-button>
    </div>

    <el-dialog
      title="活动主题"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <Theme v-if="dialogVisible" :platformid="platformid" @determine="(ruleForm.theme = $event),(dialogVisible = false)" />
    </el-dialog>
  </div>
</template>

<script>
import { readingservice } from '@/api/sourceMaterial.js'
import Theme from './theme.vue'
export default {
  components: {
    Theme
  },
  props: {
    platformid: {
      type: Number,
      default: null
    }
  },
  data() {
    var checkAger = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.appoint_day.length > 3) {
        callback(new Error('不能超过3位'))
      } else {
        callback()
      }
    }
    var checkAge = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.date[0] == this.ruleForm.date[1]) {
        callback(new Error('不能选择相同的时间'))
      } else {
        callback()
      }
    }
    return {
      // eslint-disable-next-line no-misleading-character-class
      reg: /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi,
      pickerOptions: { // 禁用当前日期之前的日期
        disabledDate(time) {
          // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' }
        ],
        charge_type: [{ required: true, message: '请选择充值类型', trigger: 'blur' }],
        date: [
          { type: 'array', required: true, message: '请选择时间', trigger: 'change' },
          { validator: checkAge, trigger: 'change' }
        ],
        price: [{ required: true, message: '请输入充值金额', trigger: 'blur' }],
        // restrictions: [{ required: true, message: '请选择限购次数', trigger: 'blur' }],
        theme: [{ required: true, message: '请选择主题', trigger: 'blur' }],
        appoint_day: [
          { required: true, message: '请输入固定天数', trigger: 'change' },
          { validator: checkAger, trigger: 'change' }
        ]
      },
      dialogVisible: false,
      ruleForm: {
        name: '', // 活动名称
        product_info: [{ // 活动内容
          charge_type: null, // 充值类型
          price: null, // 活动金额
          price1: null,
          given: null, // 赠送金额
          limit: null, // 限购次数
          is_send: 0 // 附赠优惠券
        }],
        date: [], // 时间
        enter_point: [], // 入口
        user_type: 'all', // 用户类型
        theme: null, // 主题
        permanentActivityOrNot: 1, // 是否永久活动 permanent_activities   1非永久活动 2永久性活动
        sign_text: '', // 系统文案
        sign_text1: null, // 自定义文案
        appoint_day: ''
      },
      timeoptions: [
        {
          value: 1,
          label: '指定期限'
        }, {
          value: 2,
          label: '固定天数'
        }
      ],
      time_type: 2,
      activeoptions: [
        {
          value: 1,
          label: '非永久活动'
        }, {
          value: 2,
          label: '永久性活动'
        }
      ]
    }
  },
  created() {
    window.aa = this
  },
  mounted() {

  },
  methods: {
    datavalue(val) {
      this.start_time = val[0]
      this.end_time = val[1]
    },
    submitForm(formName) {
      this.$refs[formName].validate(async(valid) => {
        const obj = this.assemblyParameters()
        if (valid && this.judgmentParameters(obj)) {
          const par = {}
          if (this.time_type === 1) {
            par.time_type = this.time_type
            par.start_time = this.ruleForm.date[0]
            par.end_time = this.ruleForm.date[1]
          } else if (this.time_type === 2) {
            par.time_type = this.time_type
            par.appoint_day = Number(this.ruleForm.appoint_day)
          } else {
            par.time_type = this.time_type
            console.log('par', par)
          }
          await readingservice({
            platform_id: this.platformid,
            activity_type: 1,
            activity_info: obj,
            ...par
          })
          this.$emit('close')
          this.$message({
            type: 'success',
            message: '添加成功!'
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    addActivityContent() {
      this.ruleForm.product_info.length < 3 && this.ruleForm.product_info.push({
        charge_type: null, // 充值类型
        charge_type_name: 'charge_type',
        price: null, // 活动金额
        price1: null,
        price_name: 'price',
        given: null, // 赠送金额
        limit: null, // 限购次数
        limit_name: 'limit',
        is_send: 0 // 附赠优惠券
      })
    },

    // 组装参数
    assemblyParameters() {
      const charge_type = {
        '书币充值': 'TICKET_RECHARGE',
        '包年': 'YEAR_ORDER',
        '包季': 'QUARTE',
        '包月': 'MONTH'
      }
      return {
        name: this.ruleForm.name,
        // start_time: this.ruleForm.permanentActivityOrNot.length ? '' : this.ruleForm.date && this.ruleForm.date[0],
        // end_time: this.ruleForm.permanentActivityOrNot.length ? '' : this.ruleForm.date && this.ruleForm.date[1],
        // enter_point: this.ruleForm.enter_point.join(','),
        permanent_activities: this.ruleForm.permanentActivityOrNot,
        enter_point: 'banner,sign,reader_alert',
        user_type: this.ruleForm.user_type === '全部' ? 'all' : this.ruleForm.user_type,
        theme: this.ruleForm.theme ? this.ruleForm.theme.item.value : this.ruleForm.theme,
        // sign_text: this.ruleForm.sign_text === '系统文案' ? this.ruleForm.sign_text : this.ruleForm.sign_text1,
        sign_text: this.ruleForm.sign_text,
        product_info: this.ruleForm.product_info.map((item) => {
          return {
            charge_type: charge_type[item.charge_type],
            price: item.charge_type === '书币充值' ? Number(item.price) : Number(item.price1),
            given: Number(item.given),
            limit: item.limit,
            //  limit: item.limit === '无限次' ? 0 : item.limit,
            is_send: item.is_send
          }
        })
      }
    },

    // 判断参数
    judgmentParameters(obj) {
      let tips = null
      // if (!obj.name) {
      //   tips = '请输入活动名称'
      // } else if (!obj.user_type) {
      //   tips = '请选择用户类型'
      // } else if (!obj.theme) {
      //   tips = '请选择主题'
      // } else if (!obj.sign_text || this.ruleForm.sign_text !== '系统文案') {
      //   tips = !obj.sign_text ? '请选择文案' : '请输入自定义文案'
      // } else if (!this.ruleForm.permanentActivityOrNot.length && !obj.start_time && !obj.end_time) {
      //   tips = '请选择活动日期'
      // }
      if (!obj.name) {
        tips = '请输入活动名称'
      } else if (!obj.user_type) {
        tips = '请选择用户类型'
      } else if (!obj.theme) {
        tips = '请选择主题'
      }
      // else if (!this.ruleForm.permanentActivityOrNot.length && !obj.start_time && !obj.end_time) {
      //   tips = '请选择活动日期'
      // }

      if (!tips) {
        for (let i = 0; i < obj.product_info.length; i++) {
          const item = obj.product_info[i]
          if (!item.charge_type) {
            tips = '请选择充值类型'
            break
          } else if (!item.price) {
            tips = '请输入充值金额'
            break
            // !item.limit !== 0 && !item.limit
          } else if (item.limit === null) {
            tips = '请选择限购次数'
            break
          }
        }
      }

      tips && this.$message({
        message: tips,
        type: 'warning'
      })

      return !tips
    },
    active(val) {
      if (val === 2) {
        this.time_type = 3
      } else {
        this.time_type = 2
      }
      console.log('val', val)
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.activityAmount{
    padding: 10px;
    background-color: #f2f2f2;
    box-sizing: border-box;
    margin-bottom: 10px;
    position: relative;
}
.activityAmount .item{
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}

.activityAmount .item .title{
   display: inline-block;
   width: 90px;
}

.addActivityAmount{
  text-align: center;
  border: 1px solid #599cd3;
  border-style: dotted;
  color: #599cd3;
  cursor: pointer;
}

.el-form-item .el-form-item{
  margin-bottom: 22px;
}

.upImgBox{
  width: 100px;
  height: 100px;
  border: 1px dotted black;
  position: relative;
  cursor: pointer;
}

.upImgBox::after{
  position: absolute;
  content: '';
  width: 1px;
  background: black;
  height: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.upImgBox::before{
  position: absolute;
  content: '';
  height: 1px;
  background: black;
  width: 50%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.upImgBox:hover{
  border-color: #599cd3;
}
.upImgBox:hover::after{
  background-color: #599cd3;
}
.upImgBox:hover::before{
  background-color: #599cd3;
}
</style>
